import { render, staticRenderFns } from "./ViewFeedbackRemark.vue?vue&type=template&id=0f05e9c0&scoped=true&"
import script from "./ViewFeedbackRemark.vue?vue&type=script&lang=js&"
export * from "./ViewFeedbackRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f05e9c0",
  null
  
)

export default component.exports